var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"py-3 pl-3"},[_vm._v("Citi"),_c('span',{staticStyle:{"color":"#fff"}},[_vm._v("Guide")])])
}]

export { render, staticRenderFns }